'use client'

import { Grid, IconButton, Stack, Typography } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import { useLabels } from '@/utils/i18n';
import { FooterRoot, FooterContainer, CopyrightRow } from './Footer.styles';
import { FooterLink } from './FooterLink';
import { useTheme } from '@mui/material/styles';

export function Footer() {
  const labels = useLabels();
  const theme = useTheme();
  const maxWidth = theme.breakpoints.values.lg;
  return (
    <FooterRoot component="footer">
      <FooterContainer sx={{ maxWidth, mx: 'auto' }}>
        <Grid container spacing={4} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="subtitle1" fontWeight={700} color="primary" gutterBottom>{labels.footer.company}</Typography>
            <Stack spacing={1}>
              <FooterLink href="/about">{labels.footer.about}</FooterLink>
              <FooterLink href="/industries">{labels.footer.industries}</FooterLink>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="subtitle1" fontWeight={700} color="primary" gutterBottom>{labels.footer.services}</Typography>
            <Stack spacing={1}>
              <FooterLink href="/services">{labels.footer.financialPlanning}</FooterLink>
              <FooterLink href="/services#assessments">{labels.footer.assessments}</FooterLink>
              <FooterLink href="/services#training">{labels.footer.training}</FooterLink>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="subtitle1" fontWeight={700} color="primary" gutterBottom>{labels.footer.resources}</Typography>
            <Stack spacing={1}>
              <FooterLink href="/privacy">{labels.footer.privacy}</FooterLink>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="subtitle1" fontWeight={700} color="primary" gutterBottom>{labels.footer.social}</Typography>
            <Stack direction="row" spacing={1}>
              <IconButton href="https://linkedin.com" color="primary" aria-label="LinkedIn" sx={{'&:hover': { bgcolor: 'primary.light' }}}><LinkedInIcon /></IconButton>
              <IconButton href="mailto:info@kibon.co.uk" color="primary" aria-label={labels.footer.email} sx={{'&:hover': { bgcolor: 'primary.light' }}}><EmailIcon /></IconButton>
            </Stack>
          </Grid>
        </Grid>
        <CopyrightRow>
          {labels.footer.copyright}
        </CopyrightRow>
      </FooterContainer>
    </FooterRoot>
  );
} 